/**
 * @module lib/booking-plans
 * Booking plan paths for customer app navigation.
 */

/** Customer-facing plan names (nav, cards, CTAs). */
export const PLAN_DISPLAY_LABELS = {
  single: "Single Session",
  monthly: "Monthly Rythm",
  yearly: "Annual Care",
};

/** Plan options shown in booking navigation UI. */
export const BOOK_PLAN_OPTIONS = [
  { plan: "single", label: PLAN_DISPLAY_LABELS.single, description: "One devoted hour for your body" },
  { plan: "monthly", label: PLAN_DISPLAY_LABELS.monthly, description: "A month of showing up" },
  { plan: "yearly", label: PLAN_DISPLAY_LABELS.yearly, description: "Transformation across seasons" },
];

/**
 * Build a `/book` route with plan and service query params.
 *
 * @param {'single'|'monthly'|'yearly'} [plan='single']
 * @param {'individual'|'group'|'therapy'} [service='individual']
 * @returns {string} Path including `plan` and `service` query string.
 */
/**
 * Parse ?plan= & ?service= for the shared /book page (single, monthly, yearly).
 * @param {URLSearchParams | { get: (key: string) => string | null }} search
 */
export function resolveBookQuery(search) {
  const planParam = (search.get("plan") || "single").toLowerCase();
  const billingPlan = ["single", "monthly", "yearly"].includes(planParam) ? planParam : "single";
  const isSubscription = billingPlan === "monthly" || billingPlan === "yearly";
  const allowedServices = isSubscription
    ? ["individual", "therapy"]
    : ["individual", "group", "therapy"];
  const serviceParam = search.get("service");
  const serviceType = allowedServices.includes(serviceParam) ? serviceParam : allowedServices[0];
  return { billingPlan, isSubscription, allowedServices, serviceType };
}

export function bookPathForPlan(plan = "single", service = "individual") {
  const p = ["single", "monthly", "yearly"].includes(plan) ? plan : "single";
  const svc =
    p === "single"
      ? ["individual", "group", "therapy"].includes(service)
        ? service
        : "individual"
      : ["individual", "therapy"].includes(service)
        ? service
        : "individual";
  return `/book?plan=${p}&service=${svc}`;
}
